
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initGoogleAdsTracking } from '@/utils/googleAds'
import { captureReferralFromUrl } from '@/utils/referralTracking'

createRoot(document.getElementById("root")!).render(<App />);

// Capture ?ref= immediately so lead attribution works even on fast submissions
captureReferralFromUrl();

// Defer Google Ads init to after render
if ('requestIdleCallback' in window) {
  (window as any).requestIdleCallback(() => { initGoogleAdsTracking(); });
} else {
  setTimeout(() => { initGoogleAdsTracking(); }, 2000);
}
